var _g;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgParking = function SvgParking(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 36,
    viewBox: "0 0 46 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#494949",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 32v-3.998a1.998 1.998 0 0 0-2-2.002h-13c-1.109 0-2 .893-2 2.002V32h17Zm-18-3.998A2.996 2.996 0 0 1 6.5 25h13c1.657 0 3 1.339 3 3.002V33h-19v-4.998Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 33v1.495c0 .291.224.505.5.505.268 0 .5-.226.5-.505V33h-1Zm-1-1h3v2.495C7.5 35.324 6.823 36 6 36c-.831 0-1.5-.664-1.5-1.505V32ZM19.5 33v1.495c0 .291.224.505.5.505.268 0 .5-.226.5-.505V33h-1Zm-1-1h3v2.495c0 .829-.677 1.505-1.5 1.505-.831 0-1.5-.664-1.5-1.505V32ZM17.462 21.309c-.058-.14-.311-.309-.457-.309h-8.01c-.14 0-.401.174-.457.309L7 25h12l-1.538-3.691Zm-9.847-.385c.213-.51.84-.924 1.38-.924h8.01c.55 0 1.167.412 1.38.924L20.5 26h-15l2.115-5.076ZM7 30.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM19 30.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM42.5 32v-3.998a1.998 1.998 0 0 0-2-2.002h-13c-1.109 0-2 .893-2 2.002V32h17Zm-18-3.998a2.996 2.996 0 0 1 3-3.002h13c1.657 0 3 1.339 3 3.002V33h-19v-4.998Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 33v1.495c0 .291.224.505.5.505.268 0 .5-.226.5-.505V33h-1Zm-1-1h3v2.495c0 .829-.677 1.505-1.5 1.505-.831 0-1.5-.664-1.5-1.505V32ZM40.5 33v1.495c0 .291.224.505.5.505.268 0 .5-.226.5-.505V33h-1Zm-1-1h3v2.495c0 .829-.677 1.505-1.5 1.505-.831 0-1.5-.664-1.5-1.505V32ZM38.462 21.309c-.058-.14-.311-.309-.457-.309h-8.01c-.14 0-.401.174-.457.309L28 25h12l-1.538-3.691Zm-9.847-.385c.213-.51.84-.924 1.38-.924h8.01c.55 0 1.167.412 1.38.924L41.5 26h-15l2.115-5.076ZM28 30.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM40 30.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.511 35H.5a.5.5 0 1 0 0 1h45.011a.5.5 0 1 0 0-1ZM23.5 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 1a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.407 8.11h1.342c1.412 0 2.226-.317 2.226-1.659 0-1.043-.597-1.652-1.646-1.652h-1.922v3.31Zm0 3.421c0 .323-.2.487-.44.487s-.433-.164-.433-.487V4.793c0-.574.258-.785.861-.785h1.963c1.506 0 2.52.967 2.52 2.443 0 1.488-1.014 2.438-2.52 2.438h-1.95v2.642Z"
  }))));
};

export { SvgParking as ReactComponent };
export default "/_next/static/media/parking.a9b0ba7a.svg";